const ID_FORSIDE = 'FORSIDE'
const ID_HOVEDSAK = '1.14250335'
const ID_TIDSLINJE = '1.14242619'
const ID_PERSONGALLERI = '1.14203037'
const ID_BEVIS = '1.14252898'
const ID_FAQ = '1.14242569'

export const menuItems = [
  { text: 'Oversikt', id: ID_FORSIDE, url: 'http://www.nrk.no/orderud' },
  { text: 'Historien', id: ID_HOVEDSAK, url: 'https://www.nrk.no/orderud---det-uloste-trippeldrapet-1.14250335' },
  { text: 'Tidslinje', id: ID_TIDSLINJE, url: 'https://www.nrk.no/orderud-tidslinje-1.14242619' },
  { text: 'Personene', id: ID_PERSONGALLERI, url: 'https://www.nrk.no/orderud/orderud---ofrene-og-de-domte-1.14203037' },
  { text: 'Bevisene', id: ID_BEVIS, url: 'https://www.nrk.no/orderud/orderud---bevisene-1.14252898' },
  { text: 'Still spørsmål', id: ID_FAQ, url: 'https://www.nrk.no/orderud/orderud-_-sporsmal-og-svar-1.14242569' }
]
